// extracted by mini-css-extract-plugin
export var fadeInAnimation = "cards-module--fadeInAnimation--e6880";
export var wrapper = "cards-module--wrapper--d0b5f";